export default __webpack_public_path__ + "static/media/nft-24-lg.dc9b829f.png";